query LeadInteractivity($companyId: String!) {
  rawData: leadInteractivityStat(companyId: $companyId) {
    weekday
    hours
  }
}
